import MissingCardPaymentQuery from "../../domain/core/payments/MissingCardPaymentQuery";
import { MissingCardPaymentModel } from "../../domain/models/MissingCardPayment";
import { IQueryMissingCardPaymentRepository } from "../../domain/ports/payments/IQueryMissingCardPaymentRepository";
import QueryService from "../QueryService";

export class MissingCardPaymentQueryService
  extends QueryService<MissingCardPaymentModel>
  implements IQueryMissingCardPaymentRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
    this.api.defaults.headers.common.Accept = "application/json";
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const missingCardPaymentQuery = new MissingCardPaymentQuery(
  new MissingCardPaymentQueryService(BASE_URL, "missing_card_payments"),
);

export { missingCardPaymentQuery };
